import { booleanAttribute, Directive, inject, input, isDevMode } from '@angular/core';
import { HotJarSurvey } from './domain/hotjar-event.model';
import { HotjarScriptService } from './hotjar-script.service';

@Directive({
  selector: '[rmaHotjarSurvey]',
  standalone: true,
  host: {
    '(click)': 'onClick()',
  },
})
export class HotjarSurveyDirective {
  private readonly hotjarService = inject(HotjarScriptService);

  public rmaHotjarSurvey = input.required<HotJarSurvey | null>();
  public rmaHotjarSurveyEnabled = input<boolean, boolean | undefined>(true, {
    transform: booleanAttribute,
  });

  public onClick(): void {
    const surveyId = this.rmaHotjarSurvey();
    if (surveyId && this.rmaHotjarSurveyEnabled()) {
      this.hotjarService.openSurvey(surveyId);
    } else if (isDevMode()) {
      console.warn('Hotjar survey not opened. Check if the survey is defined and enabled.');
    }
  }
}
